<template>
  <form class="nt-form" novalidate="true" :key="key" :id="id">
    <div>
      <slot></slot>
    </div>
    <div v-if="!customResult" :class="['nt-form__success', { 'nt-form__success--open': posted }]">
      <div class="content">
        <div>
          {{ successMessage }}
        </div>
        <div>
          <a :href="urlBack" id="btn-back" class="button button--default">{{ buttonBack }}</a>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import qs from 'qs'
import _ from 'lodash'
import axios from 'axios'
import utils from '../../../utils/utils'
import { mapActions } from 'vuex'

export default {
  name: 'nt-form',
  props: {
    id: {
      type: String,
      default: 'form-contact'
    },
    errorMessages: {
      type: Object
    },
    urlAction: {
      type: String
    },
    successMessage: {
      type: String,
      default: null
    },
    buttonBack: {
      type: String,
      default: 'Back'
    },
    urlBack: {
      type: String,
      default: '/'
    },
    customResult: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      labelValues: {},
      formData: {},
      validators: {},
      errors: [],
      key: 0,
      posted: false
    }
  },
  watch: {
    errors(values) {
      this.$nextTick(() => {
        this.focusInError(values)
      })
    }
  },
  created() {
    this.$on('changeForm', this.onChangeForm)
    this.$on('formSubmit', this.onSubmit)
    this.$on('storeRealValue', this.storeRealValue)

    Object.assign(this.formData, {
      [this.id]: 'form'
    })
  },
  methods: {
    ...mapActions([
      'changeLoading'
    ]),
    onChangeForm(val) {
      Object.assign(this.formData, val)
    },
    storeRealValue(val) {
      Object.assign(this.labelValues, val)
    },
    reload() {
      this.key = Math.floor(Math.random() * 100)
    },
    validateProperty(property, validations) {
      const prop = this.formData[property]

      _.each(validations, (validation) => {
        switch (validation) {
          case 'email':
            this.checkEmail(prop, property, validation)
            break
          case 'required':
            this.checkRequired(prop, property, validation)
            break
          default:
            break
        }
      })
    },
    checkRequired(val, property, validation) {
      if (val) return

      this.errors.push({
        [property]: this.errorMessages[validation]
      })
    },
    checkEmail(val, property, validation) {
      if (val && utils.isValidEmail(val)) return

      this.errors.push({
        [property]: this.errorMessages[validation]
      })
    },
    isValidForm() {
      this.errors = []

      _.each(this.validators, (validations, property) => {
        this.validateProperty(property, validations)
      })
      return !this.errors.length
    },
    changePosted() {
      this.posted = !this.posted

      if (this.posted && this.customResult) {
        this.$parent.$emit('posted')
      }
    },
    focusInError(values) {
      if (!values) return

      const key = _.findKey(_.get(values, 0))
      const element = document.getElementById(key)

      if (!element) return

      const topPos = element.getBoundingClientRect().top + window.scrollY - 206

      document.body.scrollTop = topPos // For Safari
      document.documentElement.scrollTop = topPos // For Chrome, Firefox, IE and Opera
    },
    pushGtm() {
      if (!window.dataLayer) {
        console.warn('DataLayer not found.')
        return
      }

      const dataToSendGTM = Object.assign({
        event: 'form-submit',
        formid: this.id,
      }, this.labelValues)

      window.dataLayer.push(dataToSendGTM)
    },
    onSubmit() {
      if (!this.isValidForm()) return

      this.changeLoading(true)

      axios.post(this.urlAction, {
        formData: qs.stringify(this.formData, {
          arrayFormat: 'brackets'
        })
      }).then((result) => {
        const { data } = result
        this.pushGtm()
        this.changePosted()
        window.console.log('[Params]: ', data.formData)
      }).catch((data) => {
        window.console.log(data)
      }).then(() => {
        this.changeLoading(false)
        this.reload()
      })
    }
  }
}
</script>
